import { getIsPriv } from 'config';
import Cookies from 'js-cookie';
// import { getOrgCode } from 'data/storage';

class GrayscalePublishing {
  /** 是否支持灰度发布，WEB支持，小程序不支持 */
  public support: boolean = getIsPriv() === false;
  /** cookie-key */
  private key = 'x-isp-code';
  /** 灰发标识 */
  private orgCodeCache: string | null = null;
  /** 当前标识 */
  public orgCode: string | null = null;

  constructor() {
    if (!this.support) return;
    this.orgCodeCache = this.orgCode = Cookies.get(this.key) || null;
  }

  /** 是否需要拉取页面资源 */
  public checkUpdate() {
    if (!this.support) return false;
    // 判断是否需要更新
    const needUpdate = !!this.orgCode && this.orgCodeCache !== this.orgCode;
    // 执行刷新
    if (needUpdate) {
      console.log('🍌🍌 ====> 灰发命中成功，重新加载页面资源');
      window.location.reload();
    }

    return needUpdate;
  }

  public set(orgCode: string) {
    if (!this.support || !orgCode) return;
    // 更新标识
    this.orgCode = orgCode;
    Cookies.set(this.key, orgCode);
  }

  public clear() {
    if (!this.support) return;
    Cookies.remove(this.key);
    this.orgCodeCache = null;
    this.orgCode = null;
  }
}

const Grayscale = new GrayscalePublishing();

export default Grayscale;
